import _get from 'lodash/get'

import { getCSRF } from './global'

export const initialState = {
  order: null,
  error: null,
  success: false,
  loading: false
}

export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST'
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS'
export const CHECKOUT_ERROR = 'CHECKOUT_ERROR'
export const CHECKOUT_ERROR_CLEAR = 'CHECKOUT_ERROR_CLEAR'

export const processOrder = (data, uuid) => async (dispatch, getState, { httpRequest }) => {
  dispatch({ type: CHECKOUT_REQUEST })
  try {
    const csrf = await dispatch(getCSRF())
    const res = await httpRequest.post(`/checkout/`, { ...data, uuid }, {
      timeout: 30000,
      headers: {
        'x-csrf-token': csrf.token
      }
    })
    if (!res) {
      dispatch({
        type: CHECKOUT_ERROR,
        order: null,
        error: null
      })
      return Promise.reject({
        order: null,
        error: null
      })
    } else {
      dispatch({
        type: CHECKOUT_SUCCESS,
        order: res.data.order,
        err: null
       })
       return Promise.resolve(res.data)
    }

  } catch (err) {
    const errData = _get(err, 'response.data', {
      data: null,
      errors: []
    })
    const { data, errors } = errData
    dispatch({
      type: CHECKOUT_ERROR,
      order: data,
      error: errors
    })

    return Promise.reject({
      data,
      errors
    })
  }
}

export const clearError = () => dispatch => {
  dispatch({
    type: CHECKOUT_ERROR_CLEAR
  })
}

const ACTION_HANDLERS = {
  [CHECKOUT_REQUEST]: state => ({
    ...state,
    error: null,
    loading: true
  }),
  [CHECKOUT_SUCCESS]: (state, { order }) => ({
    ...state,
    order,
    success: true,
    error: null,
    loading: false
  }),
  [CHECKOUT_ERROR]: (state, { order, error }) => ({
    ...state,
    order,
    error,
    loading: false
  }),
  [CHECKOUT_ERROR_CLEAR]: state => ({
    ...state,
    error: null
  })
}

export default function checkoutReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./reducers/checkout.js